import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { ApprovalStore } from '../../store/approval-store';
import { StatusValidation } from 'src/app/store/answers-store';
import { ErrorMessageComponent } from 'src/app/features/create-questionnaire-page/component/answer-questionnarie-lower-nav/error-message/error-message.component';

@Component({
    selector: 'que-approvals-bulk-action-bar',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './approvals-bulk-action-bar.component.html',
    styleUrls: ['./approvals-bulk-action-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApprovalsBulkActionBarComponent {
  #approvalStore = inject(ApprovalStore);
  #dialog = inject(MatDialog);

  selectedCount$ = toSignal(this.#approvalStore.selectedCount$, { initialValue: 0 });
  hasInvalidSelectedApproval$ = toSignal(this.#approvalStore.hasInvalidSelectedApproval$, { initialValue: false });

  approveSelected(): void {
    if (this.hasInvalidSelectedApproval$()) {
      this.#dialog.open(ErrorMessageComponent, { data: { error: StatusValidation.NotValid } });
      return;
    }
    this.#approvalStore.bulkApprove();
  }
}
